import PropTypes from "prop-types";
import { TruncateText } from "@circle-react-uikit/TruncateText";
import { Typography } from "@circle-react-uikit/Typography";

export const Filter = ({ name, value }) => (
  <span className="border-dark flex h-7 items-center gap-1.5 rounded-full border px-3">
    <span className="flex">
      <Typography.LabelXs weight="medium">{name}</Typography.LabelXs>
    </span>
    <span className="flex max-w-xs">
      <Typography.LabelXs truncate color="text-default">
        <TruncateText
          className="py-1"
          tooltipOptions={{
            content: value,
            className: "cursor-pointer",
          }}
        >
          <span>{value}</span>
        </TruncateText>
      </Typography.LabelXs>
    </span>
  </span>
);

Filter.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
};
